export default function useCartStorage() {
    const CART_KEY = "cart";

    function storageItems() {
        try {
            return JSON.parse(localStorage.getItem(CART_KEY)) ?? [];
        } catch (error) {
            return [];
        }
    }

    function updateLocalStorage(ctx) {
        Cookies.setItem(CART_KEY, ctx.items.map((e) => e.id).join("|"));
        localStorage.setItem(CART_KEY, JSON.stringify(ctx.items));
    }

    function emptyLocalStorage(ctx) {
        const event = {};
        event.product_ids = ctx.items.map((el) => el.id);
        event.currency = currency;
        event.order_id = ctx.order?.id;
        event.webstore_id = document.head.querySelector('meta[name="webshop-id"]').content;
        event.value = ctx.totalPrice + (ctx.shippingPrice ?? 0) + (ctx.paymentPrice ?? 0);
        event.num_items = ctx.items.map((el) => el.quantity);
        event.items = ctx.items.map((el) => {
            return {
                item_id: el.id,
                item_sku: el.sku,
                item_name: el.name,
                item_serial: el?.serial,
                price: el.price,
                quantity: el.quantity,
            };
        });
        AppEvents.callEvent("PURCHASE", event);
        // the order page the customer may open later (the e-mail link) must not measure this purchase again
        if (event.order_id) {
            try {
                localStorage.setItem("purchase_reported_" + event.order_id, "1");
            } catch (e) {
                // no storage: the order page's own once-per-order check is the only one then
            }
        }
        localStorage.setItem(CART_KEY, JSON.stringify([]));
        Cookies.setItem(CART_KEY, "");
    }

    return { storageItems, updateLocalStorage, emptyLocalStorage };
}